import { useState } from 'react';
const useCustomHook = () => {
  const [activeTab, setActiveTab] = useState('1');

  return {
    activeTab,
    setActiveTab,
  };
};

export default useCustomHook;
